import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalFooter, Spinner } from 'reactstrap';
import { isMobile } from 'react-device-detect';
import Translate from '../common/Translate';

const ExpressSale = ({ isOpen, setShowExpressSale, postOffer, postAnnonceAt, recordId, setRedirect }) => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setisLoading] = useState(false);
  const [apiErrorMessage, setApiErrorMessage] = useState(false);
  const [redirectAfterClose, setRedirectAfterClose] = useState(false);

  const handleClose = async () => {
    if (redirectAfterClose) {
      setRedirect(`/files/${recordId}`);
    }
    setShowExpressSale(false);
  };
  const submit = async () => {
    try {
      setRedirectAfterClose(false);
      setApiErrorMessage(null);
      setisLoading(true);
      const response = await postOffer();
      if (response.id) {
        await postAnnonceAt({ sale_offer_type: '/api/sale_offer_types/1', express_sale: true, vehicleId: response.id });
        // setRedirectAfterClose(true);
      } else {
        setApiErrorMessage(response.message);
      }
      setIsSubmitted(true);
    } catch (e) {
      setApiErrorMessage(e.message);
    }
    setisLoading(false);
  };

  return (
    <Modal isOpen={isOpen} toggle={() => handleClose()} centered>
      <ModalBody className={(isMobile && 'remove-padding') || 'pb-0'}>
        <div className={!isMobile && 'p-3'}>
          <div className="form-group justify-content-center text-Alert" data-cy="textAlertLogout">
            {(!isSubmitted && <Translate code="expressSalePopUpConfirmation" />) || (
              <Translate code="expressSalePopUpClose" />
            )}

            {apiErrorMessage && <p className="text-danger">{apiErrorMessage}</p>}
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        {(!isSubmitted && (
          <div className="model-footer">
            <button className="btn btn-3 mr-2" type="button" onClick={() => handleClose()}>
              <Translate code="cancel" />
            </button>
            <button className="btn btn-1" type="button" onClick={() => submit()}>
              {isLoading && <Spinner size="sm" />}
              <Translate code="submit" />
            </button>
          </div>
        )) || (
          <button className="btn btn-1" type="button" onClick={() => handleClose()}>
            <Translate code="close" />
          </button>
        )}
      </ModalFooter>
    </Modal>
  );
};

ExpressSale.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  recordId: PropTypes.string.isRequired,
  setShowExpressSale: PropTypes.func.isRequired,
  postOffer: PropTypes.func.isRequired,
  setRedirect: PropTypes.func.isRequired,
  postAnnonceAt: PropTypes.func.isRequired,
};

export default ExpressSale;
